import { CreateFileV2 } from '../../File';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { NoteReceivableFormValues } from '..';
import { useWindowSize } from 'react-use';
import { MDTailwindMinPixelBreakpointWidth } from '../../util/theme.util';
import { useNoteReceivableFormContext } from '../context';

interface NoteReceivableCreateFileInputProps {
  className?: string;
}

export const NoteReceivableCreateFileInput = ({ className }: NoteReceivableCreateFileInputProps) => {
  const { t: tForm } = useTranslation('form');
  const { width: windowWidth } = useWindowSize();
  const { setValue, watch } = useFormContext<NoteReceivableFormValues>();
  const { householdID } = useNoteReceivableFormContext();

  const [pendingFiles] = watch(['pendingFiles']);

  return (
    <CreateFileV2
      className={className}
      tenantID={householdID}
      label={tForm('general-add-related-documents')}
      size={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'small' : 'large'}
      onFileCreation={(file) => {
        setValue('pendingFiles', (pendingFiles || []).concat(file));
      }}
    />
  );
};
